import React, { useState, useEffect } from 'react';
import { Modal, Button, ListGroup, Form, Pagination } from 'react-bootstrap';
import apiClient from '../api'; // Importa la instancia de axios configurada
import { handleError } from '../utils/errorHandler'; // Import handleError

const LOGS_PER_PAGE = 15;

const LogModal = ({ show, handleClose, logs: propLogs, title = "Bitácora de Cambios", onGoToTransaction }) => {
  const [modalLogs, setModalLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalLogs, setTotalLogs] = useState(0);

  useEffect(() => {
    if (show) {
      // Reset states when modal is opened
      setSearchTerm('');
      setCurrentPage(1);
      setTotalLogs(0);
    }
  }, [show]);

  useEffect(() => {
    const fetchLogs = async () => {
      if (show && !propLogs) {
        setLoading(true);
        try {
          const params = { 
            search: searchTerm, 
            skip: (currentPage - 1) * LOGS_PER_PAGE, 
            limit: LOGS_PER_PAGE 
          };
          const response = await apiClient.get('/logs/', { params });
          setModalLogs(response.data.logs);
          setTotalLogs(response.data.total);
        } catch (err) {
          handleError(err, 'Error al cargar la bitácora.');
        } finally {
          setLoading(false);
        }
      }
    };

    const handler = setTimeout(() => {
      if (show) {
        if (propLogs) {
            const filtered = propLogs.filter(log => 
                log.action.toLowerCase().includes(searchTerm.toLowerCase()) ||
                log.details.toLowerCase().includes(searchTerm.toLowerCase()) ||
                (log.user_email && log.user_email.toLowerCase().includes(searchTerm.toLowerCase()))
            );
            setModalLogs(filtered);
            setTotalLogs(filtered.length);
        } else {
            fetchLogs();
        }
      }
    }, 300);

    return () => {
        clearTimeout(handler);
    };

  }, [show, propLogs, searchTerm, currentPage]);

  const pageCount = propLogs ? Math.ceil(totalLogs / LOGS_PER_PAGE) : Math.ceil(totalLogs / LOGS_PER_PAGE);

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Control
          type="text"
          placeholder="Buscar..."
          value={searchTerm}
          onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
          className="mb-3"
        />
        {loading && <p>Cargando...</p>}
        {!loading && modalLogs && modalLogs.length > 0 ? (
          <ListGroup variant="flush">
            {modalLogs.map((log) => (
              <ListGroup.Item key={log.id} className="d-flex justify-content-between align-items-start">
                <div className="ms-2 me-auto">
                  <div className="fw-bold">{log.action}</div>
                  <div>
                    {log.details}
                    {log.transaction_id && onGoToTransaction && (
                        <Button 
                            variant="link" 
                            size="sm" 
                            onClick={() => onGoToTransaction(log.transaction_id)}
                            className="p-0 ms-2"
                        >
                            (Ir a transacción)
                        </Button>
                    )}
                  </div>
                  <small className="text-muted">Por: {log.user_email || 'Sistema'}</small>
                </div>
                <small className="text-muted">{new Date(log.timestamp).toLocaleString('es-CL', { timeZone: 'America/Santiago' })}</small>
              </ListGroup.Item>
            ))}
          </ListGroup>
        ) : (!loading && <p>No se encontraron registros.</p>)}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Pagination>
            <Pagination.Prev onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1} />
            <Pagination.Item active>{currentPage}</Pagination.Item>
            <Pagination.Next onClick={() => setCurrentPage(p => Math.min(pageCount, p + 1))} disabled={currentPage === pageCount} />
        </Pagination>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LogModal;
